import React from 'react';
import { NavLink } from 'react-router-dom';
import ethicsPageData from '../content/ethics-page.json';


// Utility function to make links clickable
const convertTextToLinks = (text) => {
    const replacements = [
        {
            pattern: /Guidelines On Good Publication practice/gi,
            url: "https://publicationethics.org/files/u7141/1999pdf13.pdf",
            label: "Guidelines On Good Publication practice"
        },
        {
            pattern: /Core Practices/gi,
            url: "https://publicationethics.org/about/what-we-do/our-story/why-core-practices-were-replaced-topics",
            label: "Core Practices"
        }
    ];

    let result = [text];

    replacements.forEach(({ pattern, url, label, download }) => {
        result = result.flatMap((chunk, index) => {
            if (typeof chunk !== 'string') return [chunk];
            return chunk.split(pattern).flatMap((part, i, arr) =>
                i < arr.length - 1
                    ? [
                          part,
                          <a
                              key={`${label}-${index}-${i}`}
                              href={url}
                              target="_blank"
                              rel="noopener noreferrer"
                              download={download || undefined}
                              className="link"
                          >
                              {label}
                          </a>
                      ]
                    : [part]
            );
        });
    });

    return result;
};


const EthicsPageContent = () => {
    const { text: ethicsText, guidelines } = ethicsPageData;

    return (
        <div>
            <section className="main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="main-text">
                                <h2>Ethical Guidelines</h2>
                                <div className="bt-option">
                                    <NavLink to="/">Home</NavLink>
                                    <span>Ethics</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="ethics-section spad">
                <div className="container">
                    <div className="section-title">
                        <p className="f-para">{convertTextToLinks(ethicsText)}</p>
                    </div>

                    {Object.entries(guidelines).map(([sectionTitle, entries], idx) => (
                        <div className="section-title" key={idx}>
                            <h3>{sectionTitle}</h3>

                            {entries.map((item, index) => {
                                const numberLabel = `${index + 1}.`;

                                // Number top-level only
                                if (item.title && item.description) {
                                    return (
                                        <div key={index} style={{ marginBottom: '1rem' }}>
                                            <h5><strong>{numberLabel} {item.title}</strong></h5>
                                            <p className="f-para">{convertTextToLinks(item.description)}</p>
                                        </div>
                                    );
                                }

                                if (item.subtopics) {
                                    return (
                                        <div key={index} style={{ marginBottom: '1rem' }}>
                                            <h5><strong>{numberLabel} {item.title}</strong></h5>
                                            <ul>
                                                {item.subtopics.map((sub, subIndex) => (
                                                    <li key={subIndex}>
                                                        <strong>{sub.title}:</strong> {convertTextToLinks(sub.description)}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    );
                                }

                                if (item.subsections) {
                                    return (
                                        <div key={index} style={{ marginBottom: '1rem' }}>
                                            <h5><strong>{numberLabel} {item.title}</strong></h5>
                                
                                            {item.subsections.map((section, secIndex) => (
                                                <div key={secIndex} className="guideline-subsection">
                                                    <h5>{section.section}</h5>
                                                    <ul className="guideline-sublist">
                                                        {section.items.map((entry, entryIdx) => (
                                                            <li key={entryIdx}>
                                                                <strong>{entry.title}:</strong> {convertTextToLinks(entry.description)}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                    );
                                }
                                
                                return null;
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default EthicsPageContent;